import I18n from '@/plugins/i18n';
const { t } = I18n.global;

export const loginFormRules = {
  username: {
    required: true,
    trigger: ['blur', 'input'],
    message: t('views.login.form.username.error'),
  },
  password: {
    required: true,
    trigger: ['blur', 'input'],
    message: t('views.login.form.password.error'),
  },
  captcha: {
    required: true,
    trigger: ['blur', 'input'],
    message: t('views.login.form.captcha.error'),
  },
};
